import cx from 'classnames';
import { match } from 'ts-pattern';

import getStatusIconColour from 'lib/common/utils/presence/getStatusIconColour';

import Badge from '../../Badge';
import { BadgeTypes } from '../../Badge/Badge';

import COLOURS from 'css/export-vars.module.scss';

import styles from './presence-badge.module.scss';

const PRESENCE_BADGE_MAX_WIDTH = 200;

export default function PresenceBadge({ presence, className }: { presence: string | undefined; className?: string }) {
  const statusColour = presence ? getStatusIconColour(presence) : void 0;
  const badgeColour = statusColour === COLOURS.white ? 'darkGrey' : statusColour;

  return (
    <Badge
      ellipsis
      maxWidth={PRESENCE_BADGE_MAX_WIDTH}
      label={presence}
      type={match(badgeColour)
        .with('success', () => BadgeTypes.SUCCESS)
        .with('darkGrey', () => BadgeTypes.NEUTRAL)
        .with('white', () => BadgeTypes.NEUTRAL)
        .with('danger', () => BadgeTypes.DANGER)
        .otherwise(() => BadgeTypes.WARNING)}
      className={cx(styles['badge-override'], className)}
    />
  );
}
